import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { VEHICLE_FIELDS, VEHICLE_TYPES, vehicleMissing } from "@/lib/gps";
import { api, errMsg } from "@/lib/api";

const OPTIONAL = { vin: " (placas o VIN)", plates: " (placas o VIN)", economic_number: " (opcional)" };

export const VehicleCard = ({ wo, setWo, editable }) => {
  const [v, setV] = useState(wo.extensions?.vehicle || {});
  const [saving, setSaving] = useState(false);
  const set = (k, x) => setV({ ...v, [k]: x });
  const missing = vehicleMissing(wo.extensions?.vehicle);
  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put(`/work-orders/${wo.id}/vehicle`, v);
      setWo((w) => ({ ...w, extensions: { ...(w.extensions || {}), vehicle: data } }));
      setV(data);
      toast.success("Datos del vehículo guardados");
    } catch (e) { toast.error(errMsg(e)); } finally { setSaving(false); }
  };
  return (
    <div className="space-y-3" data-testid="vm-vehicle-card">
      <p className="text-xs text-muted-foreground">Se captura una sola vez y la usan todos los servicios de esta OS (MDVR, Dashcam y GPS adicional).</p>
      <div className="grid grid-cols-2 gap-2">
        <div className="col-span-2 space-y-1 sm:col-span-1">
          <Label className="text-[11px] text-muted-foreground">Tipo de vehículo</Label>
          <Select value={v.vehicle_type || ""} onValueChange={(x) => set("vehicle_type", x)} disabled={!editable}>
            <SelectTrigger className="h-10" data-testid="vm-vehicle-type-select"><SelectValue placeholder="Selecciona" /></SelectTrigger>
            <SelectContent>{VEHICLE_TYPES.map(([k, l]) => <SelectItem key={k} value={k} data-testid={`vm-vehicle-type-${k}`}>{l}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        {v.vehicle_type === "otro" && (
          <div className="col-span-2 space-y-1 sm:col-span-1">
            <Label className="text-[11px] text-muted-foreground">Describe el tipo</Label>
            <Input className="h-10" value={v.vehicle_type_other || ""} disabled={!editable} onChange={(e) => set("vehicle_type_other", e.target.value)} data-testid="vm-vehicle-type-other-input" />
          </div>
        )}
        {VEHICLE_FIELDS.map(([k, l]) => (
          <div key={k} className="space-y-1">
            <Label className="text-[11px] text-muted-foreground">{l}{OPTIONAL[k] || ""}</Label>
            <Input className="h-10" value={v[k] || ""} disabled={!editable} onChange={(e) => set(k, e.target.value)} data-testid={`vm-vehicle-${k}-input`} />
          </div>
        ))}
      </div>
      {missing.length > 0 && <p className="text-xs text-amber-300" data-testid="vm-vehicle-missing">Falta: {missing.join(", ")}</p>}
      {editable && <Button className="h-12 w-full" onClick={save} disabled={saving} data-testid="vm-vehicle-save-button">{saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Guardar vehículo</Button>}
    </div>
  );
};
